"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var React = require("react");
var lang_1 = require("../../../utils/lang");
var Image_1 = require("../../common/Image");
var admin_1 = require("../../../services/page/admin");
var time_1 = require("../../../utils/time");
var styles = require("./index.scss");
var store_1 = require("./store");
var banner_1 = require("../../utils/banner");
var getLang = lang_1.getLitbLangFn();
var classnames_1 = require("classnames");
var CountBanner = (function (_super) {
    __extends(CountBanner, _super);
    function CountBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.store = new store_1.CountDownStore(props.moduleId, props.state, props.timer);
        return _this;
    }
    CountBanner.prototype.componentWillUnmount = function () {
        clearInterval(this.store.intervalId);
    };
    CountBanner.prototype.renderTimeSpan = function () {
        var _a = this.store, remainSec = _a.remainSec, state = _a.state;
        if (!remainSec) {
            return [];
        }
        var onlyOnGoing = state === admin_1.TActState.OnGoing ? time_1.EnFormateDays(remainSec) * time_1.SECONDS_IN_A_DAY : 0;
        var newTime = remainSec - onlyOnGoing;
        var hours = Math.floor(newTime / 3600) + "";
        var minutes = (Math.floor(newTime / 60) % 60) + "";
        var seconds = (newTime % 60) + "";
        return [hours, minutes, seconds].reduce(function (memo, item, index) {
            var i = __spreadArrays(memo);
            var timeSpan = item;
            if (index !== 0) {
                i.push(React.createElement("span", { key: index, className: styles.splitter }, ":"));
            }
            if (item.length === 1) {
                timeSpan = "0" + timeSpan;
            }
            return __spreadArrays(i, timeSpan.split("").map(function (n, idx) { return (React.createElement("span", { key: index + "" + idx, className: styles.timeSpan }, n)); }));
        }, []);
    };
    Object.defineProperty(CountBanner.prototype, "title", {
        get: function () {
            var _a = this.store, state = _a.state, time = _a.timer.time, remainSec = _a.remainSec;
            switch (state) {
                case admin_1.TActState.ComingSoon:
                    return getLang("Starts On") + " " + time_1.EnFormateDate(parseInt(time.start, 10) * 1000);
                case admin_1.TActState.OnGoing:
                    return getLang("Ends In") + " " + time_1.EnFormateDays(remainSec) + " days";
                default:
                    return "";
            }
        },
        enumerable: false,
        configurable: true
    });
    CountBanner.prototype.render = function () {
        var _a;
        var _b = this.props, id = _b.id, banner = _b.banner;
        var state = this.store.state;
        if (state === admin_1.TActState.Ended || state === admin_1.TActState.UnkonwnActState) {
            return (React.createElement("div", { className: styles.expiredInfo },
                React.createElement("h1", null, getLang("We‘re sorry，the offer has expired."))));
        }
        if (!banner || !banner.img) {
            return null;
        }
        var realHeight = banner_1.transformBannerSize({
            selfWidth: 1200,
            width: banner.width,
            height: banner.height
        }).height;
        return (React.createElement("a", { id: id, className: classnames_1.default(styles.countDownContainer, (_a = {}, _a[styles.adorCountDownContainer] = false, _a)), href: banner.link || undefined, target: "_blank", style: { height: realHeight || "auto" } },
            React.createElement(Image_1.default, { key: banner.img, className: styles.background, src: banner.img, params: "imageView2/2" }),
            React.createElement("div", { className: styles.main },
                React.createElement("div", { className: styles.countDown },
                    React.createElement("h1", null, this.title),
                    React.createElement("div", null, this.renderTimeSpan())))));
    };
    CountBanner = __decorate([
        mobx_react_1.observer
    ], CountBanner);
    return CountBanner;
}(React.Component));
exports.default = CountBanner;
